import {
  Field,
  FieldError,
  FieldLabel,
  type ItemOptionProps,
  Search,
} from "@/components/ui";
import type {
  ControllerFieldState,
  ControllerRenderProps,
} from "react-hook-form";
import {
  type AOEAnswerCoding,
  type AOEQuestion,
  AOEQuestionAnswerType,
} from "../../../network/useRetrieveAOEForOrder";

import type { AOEFormSchema } from "../schemas";

export const FreetextableSelectQuestion = ({
  question,
  field,
  fieldState,
  disabled,
}: {
  question: AOEQuestion;
  field: ControllerRenderProps<
    AOEFormSchema,
    `questionnaires.${string}.${string}`
  >;
  fieldState: ControllerFieldState;
  disabled: boolean;
}) => {
  const value = field.value as AOEAnswerCoding | string | undefined;
  const valueDisplay =
    typeof value === "string" ? value : (value?.display ?? "");

  const options =
    question.answerOptions?.map((option) => ({
      value: option.valueCoding?.code ?? option.valueString ?? "",
      label: option.valueCoding?.display ?? option.valueString ?? "",
      answerType: option.valueCoding
        ? AOEQuestionAnswerType.CODING
        : AOEQuestionAnswerType.TEXT,
    })) ?? [];

  const handleItemSelected = (item: ItemOptionProps) => {
    const option = options.find((option) => option.value === item.value);
    if (item.isFreeText || option?.answerType === AOEQuestionAnswerType.TEXT) {
      field.onChange(item.value);
    } else {
      field.onChange({
        code: item.value,
        display: item.label,
      });
    }
  };

  return (
    <Field data-invalid={fieldState.invalid}>
      <FieldLabel htmlFor={field.name}>
        {question.required && "*"}
        {question.question}
      </FieldLabel>
      <Search
        input={valueDisplay}
        options={options}
        onInputChange={(input) => {
          field.onChange(input);
        }}
        onItemSelected={handleItemSelected}
        allowFreeText={true}
        freeTextPrefix=""
        noResultsText=""
        openOnFocus={true}
        openWithoutInput={true}
        shouldFilter={true}
        disabled={disabled}
      />
      <FieldError errors={[fieldState.error]} />
    </Field>
  );
};
